import React, { useState } from "react";
import BulkCsvModal from "./BulkCsvModal";

const classByProvider = {
  GOOGLE: "providerGoogle",
  MICROSOFT: "providerMicrosoft",
  ZOHO: "providerZoho",
  YAHOO: "providerYahoo",
  ICLOUD: "providerIcloud",
  GODADDY: "providerGodaddy",
  PROTONMAIL: "providerProtonmail",
  FASTMAIL: "providerFastmail",
  UNKNOWN: "providerUnknown"
};

const labelByProvider = {
  GOOGLE: "Google",
  MICROSOFT: "Microsoft",
  ZOHO: "Zoho",
  YAHOO: "Yahoo",
  ICLOUD: "iCloud",
  GODADDY: "GoDaddy",
  PROTONMAIL: "ProtonMail",
  FASTMAIL: "Fastmail",
  UNKNOWN: "Unknown"
};

const ProviderBadge = (props = {}) => {
  const { provider = "UNKNOWN" } = props || {};
  return (
    <span
      className={`bulkCsvProviderBadge ${classByProvider[provider] ||
        "providerUnknown"}`}
    >
      {labelByProvider[provider] || "Unknown"}
    </span>
  );
};

const StepReview = (props = {}) => {
  const {
    onClose = () => {},
    onBack = () => {},
    onNext = () => {},
    rows = [],
    connecting = false
  } = props || {};
  const [filter, setFilter] = useState("all");

  const readyRows = rows.filter(row => row.status === "ready");
  const errorRows = rows.filter(row => row.status !== "ready");
  const shownRows =
    filter === "all" ? rows : filter === "ready" ? readyRows : errorRows;

  const hasMicrosoftRows = rows.some(row => row.provider === "MICROSOFT");

  return (
    <BulkCsvModal
      title="Review & connect"
      onClose={onClose}
      wide
      footer={
        <>
          <button
            type="button"
            id="bulkCsvReviewBack"
            className="bulkCsvBtnGhost"
            onClick={onBack}
          >
            Back
          </button>
          <button
            type="button"
            id="bulkCsvReviewConnect"
            className="bulkCsvBtnPrimary"
            disabled={!readyRows.length || connecting}
            onClick={() => onNext(readyRows)}
          >
            {connecting ? "Connecting..." : `Connect ${readyRows.length} inboxes`}
          </button>
        </>
      }
    >
      {hasMicrosoftRows && (
        <div className="bulkCsvWarningBox" style={{ marginBottom: 12 }}>
          <div className="warningText">
            Some rows use a Microsoft host. Make sure SMTP Authentication is
            enabled on those mailboxes before connecting.
          </div>
        </div>
      )}

      <div className="bulkCsvFilterTabs">
        {[
          ["all", "All rows", rows.length],
          ["ready", "Ready", readyRows.length],
          ["error", "Errors", errorRows.length]
        ].map(([key, label, count]) => (
          <button
            key={key}
            type="button"
            id={`bulkCsvFilter-${key}`}
            className={`filterTab ${filter === key ? "active" : ""}`}
            onClick={() => setFilter(key)}
          >
            {label}
            <span className="filterTabCount">{count}</span>
          </button>
        ))}
      </div>

      {shownRows.length ? (
        <div className="bulkCsvTableWrapper">
          <table>
            <thead>
              <tr>
                <th style={{ width: "46%" }}>Email</th>
                <th style={{ width: "20%" }}>Provider</th>
                <th style={{ width: "34%" }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {shownRows.map((row, index) => (
                <tr key={`${row.email}-${index}`}>
                  <td title={row.email}>{row.email}</td>
                  <td>
                    <ProviderBadge provider={row.provider} />
                  </td>
                  <td>
                    {row.status === "ready" ? (
                      <span className="bulkCsvRowStatusTag ready">
                        Ready to connect
                      </span>
                    ) : (
                      <span
                        className="bulkCsvRowStatusTag errored"
                        title={row.reason}
                      >
                        {row.reason}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="bulkCsvEmptyState">
          {filter === "error"
            ? "No errors. All inboxes are ready to connect."
            : "No rows to show."}
        </div>
      )}

      <div className="bulkCsvReviewFootnote">
        <span>ℹ</span>
        <span>
          Only <strong>Ready to connect</strong> rows will be imported. Fix
          errors and re-upload to add skipped inboxes.
        </span>
      </div>
    </BulkCsvModal>
  );
};

export default StepReview;
export { StepReview };
